import React, { useRef, useEffect } from "react";
import Modal from "react-modal";
import './CalendarModal.css';

Modal.setAppElement("#root");

const CalendarModal = ({ isOpen, date, event, onClose }) => {
  const overlayRef = useRef(null);

  const closeModal = () => {
    onClose();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        closeModal();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="calendar-modal-overlay">
      <div ref={overlayRef} className="calendar-modal">
        <button onClick={closeModal} className="close-button">×</button>
        <div className="calendar-modal-content">
          {date && (
            <div className="calendar-modal-date">
              <i className="fa fa-calendar"></i>
              {date.toLocaleDateString(undefined, { 
                weekday: 'long', 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </div>
          )}
          <div className="calendar-modal-event-info">
            <h2 className="calendar-modal-event-title">{event.title}</h2>
            <div className="calendar-modal-event-details">
              <div className="calendar-modal-event-time">
                <i className="fa fa-clock-o"></i>
                {new Date(event.start_time).toLocaleTimeString([], { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })} - {new Date(event.end_time).toLocaleTimeString([], { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </div>
              <div className="calendar-modal-event-location">
                <i className="fa fa-map-marker"></i>
                {event.location}
              </div>
            </div>
            <div 
              className="calendar-modal-event-description"
              style={{ 
                backgroundColor: event.backgroundColor || '#6fb4f0'
              }}
            >
              {event.description}
            </div>
            {event.image && (
              <div className="calendar-modal-event-image">
                <img src={event.image} alt={event.title} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarModal;
